<template>
  <div class="video-control">
    <div class="video-control__wrapper">
      <span class="video-control__title">Skip to:</span>
      <button class="video-control__button active">Highlights</button>
      <button class="video-control__button">Operational Review</button>
      <button class="video-control__button">Financial Review</button>
      <button class="video-control__button">Q&amp;A</button>
    </div>
    <div class="video-control__prev-next">
      <BaseButton variant="secondary" class="text-base mx-2">Previous</BaseButton>
      <BaseButton variant="secondary" class="text-base">Next</BaseButton>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="postcss">
.video-control {
  @apply hidden relative flex-wrap justify-between mb-8;
}
.video-control__wrapper {
  @apply border border-t-0 border-l-0 border-r-0 border-body w-full;
}
.video-control__title {
  @apply font-semibold;
}
.video-control__button {
  @apply bg-white text-black font-semibold px-2 py-4 mx-2;
}
.video-control__button.active {
  @apply border-4 border-t-0 border-l-0 border-r-0 border-secondary text-secondary;
}
.video-control__button:hover {
  @apply text-secondary;
}
.video-control__button:focus {
  @apply outline-none;
}
.video-control__prev-next {
  @apply flex items-center;
}
@screen md {
  .video-control {
    @apply flex flex-no-wrap;
  }
  .video-control__wrapper {
    @apply w-auto;
  }
}
@screen lg {
  .video-control {
    @apply w-10/12 mx-auto mb-12;
  }
  .video-control__wrapper {
    @apply mx-2;
  }
  .video-control__button {
    @apply mx-4;
  }
}
</style>